import React from "react";
import { func, string } from "prop-types";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import Credential from "pages/_components/fields/credentials/Credential";
import Button from "pages/_components/Button";
import useSchema from "hooks/useSchema";
import * as Yup from "yup";

const CredentialForm = ({ onSubmit, credentialType }) => {
    const { stringRequired } = useSchema();
    return (
        <Formik
            initialValues={{
                credential: "",
            }}
            validationSchema={Yup.object().shape({
                credential: stringRequired,
            })}
            onSubmit={(values, formikBag) => onSubmit(values, formikBag)}>
            {({ isSubmitting }) => (
                <Form>
                    <Row className="form-actions">
                        <Col xs={12} md={4} mdOffset={2} lg={3} lgOffset={3}>
                            <Field
                                idForm="form.credential"
                                name="credential"
                                labelText={`form.credential.${credentialType}.label`}
                                placeholderText={credentialType === "otp" ? "Ej: 120573" : "Ej: Ju@n_123"}
                                component={Credential}
                                type={credentialType}
                            />
                        </Col>
                        <Col xs={12} md={4} mdOffset={6} lg={3} lgOffset={6} className="align-items-end">
                            <div className="form-group hidden-label">
                                <div className="button-group">
                                    <Button
                                        block
                                        type="submit"
                                        label="global.send"
                                        bsStyle="primary"
                                        loading={isSubmitting}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Form>
            )}
        </Formik>
    );
};

CredentialForm.propTypes = {
    onSubmit: func.isRequired,
    credentialType: string.isRequired,
};

export default CredentialForm;
